/** @jsx jsx */

import { Fragment as _, useState } from 'react';
import { css, jsx } from '@emotion/core';


const Star = ({
  index,
  rating,
  color,
  selected,
  onHover,
  isHovered,
  onClick,
}) => {
  const [isClicked, setIsClicked] = useState(false);
  const [hasFocus, setHasFocus] = useState(false);
  const size = [114, 108];


  return (
    <div
      css={css`
        position: relative;
        width: ${size[0] / 1.5}px;
        height: ${size[1] / 1.5}px;
        margin: 0 10px;
        transition: all 0.2s;

        @media (max-width: 480px) {
          width: ${size[0] / 2}px;
          height: ${size[1] / 2}px;
          margin: 0 5px;
        }
      `}
    >
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 114 108">
        <polygon
          css={css`
            fill: ${selected ? color : 'transparent'};
            stroke: ${color};
            stroke-width: ${hasFocus ? 3 : 1};
            transition: all 0.2s;
            cursor: pointer;

            ${selected &&
            !isClicked &&
            `&:hover {
              opacity: 0.5;
              }`}

            ${isHovered &&
            `
              fill: ${color};
            `}
          `}
          points="57 88.5 22.32 106.73 28.94 68.12 0.89 40.77 39.66 35.13 57 0 74.34 35.13 113.11 40.77 85.06 68.12 91.68 106.73 57 88.5"
        />
      </svg>
      <button
        aria-label={`star ${index + 1} of 5`}
        aria-pressed={rating == index}
        css={css`
          position: absolute;
          left: 0;
          top: 0;
          width: 100%;
          height: 100%;
          border: none;
          outline: none;
          background: transparent;
        `}
        onFocus={() => {
          setHasFocus(true);
        }}
        onBlur={() => {
          setHasFocus(false);
        }}
        onClick={() => {
          setIsClicked(true);
          onClick();
        }}
        onMouseOver={() => {
          onHover(index);
        }}
        onMouseOut={() => {
          onHover();
        }}
        onMouseLeave={() => setIsClicked(false)}
      />
    </div>
  );
};

export default Star;
